import { render, staticRenderFns } from "./CourseCreateModal.vue?vue&type=template&id=0dbc6e33&"
import script from "./CourseCreateModal.vue?vue&type=script&lang=js&"
export * from "./CourseCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports